export const UPDATE = 'persist/UPDATE'

export const update = payload => ({
  type: UPDATE,
  payload,
})



// WEBPACK FOOTER //
// ./src/actions/PersistAction.js